export default __webpack_public_path__ + "assets/css/fa-solid-900.woff2";